module.exports = __webpack_public_path__ + "img/farzana-christopher-80.932530c0.jpg";